<template>
  <div>
    <b-modal
      class="mc-modal"
      id="modal-shortcut-change-status"
      ref="mc-modal-change-status"
      :title="$t('maintenance.changeToService')"
      size="lg"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('maintenance.changeStatusWarning', { data: selectedDataLength }) }}
        </p>

        <McAlert
          v-if="hasMO"
          :text="$t('maintenance.changeStatusInfo')"
          variant="info"
          withIcon
          class="d-flex justify-content-start mt-3"
        />
      </div>

      <template #modal-footer="{ cancel }">
        <div :class="`w-100 d-flex justify-content-${hasMO ? 'between' : 'end'}`">
          <McButton
            v-if="hasMO"
            variant="secondary"
            icon="icon-outline_file-add"
            class="me-2"
            :text="$t('maintenance.createMO')"
            @click="handleCreateMO"
          />

          <div class="d-flex">
            <McButton
              variant="secondary"
              class="me-2"
              :text="$t('global.cancel')"
              @click="cancel()"
            />
            <McButton
              variant="primary"
              :text="$t('maintenance.changeToService')"
              @click="handleChangeService"
            />
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert.vue'
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import { BULK_UPDATE_SERVICE_SCHEDULE } from '@/services/api/maintenance/serviceSchedules'

export default {
  components: {
    McButton,
    McAlert,
  },

  props: {
    selectedDataLength: {},
    selectedIds: {},
    selectedItems: {},
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    hasMO() {
      return this.hasAccess([
        'service_order:read',
        'service_order:update',
        'service_order:create',
        'service_order:delete',
      ])
    },
  },

  methods: {
    async handleChangeService() {
      const serviceSchedules = this.selectedItems.map((item) => {
        return {
          serviceId: item.serviceId,
          type: item.type,
          vehicleId: item.vehicleId,
        }
      })

      const input = {
        forceInProgress: true,
        serviceSchedules: serviceSchedules,
      }

      await this.$apollo
        .mutate({
          mutation: BULK_UPDATE_SERVICE_SCHEDULE,
          variables: {
            input: input,
          },
        })
        .then((res) => {
          if (res.data.updateServiceSchedules.isSuccessful)
            this.$mcToast.success(this.$t('maintenance.alert.successInProgress'))
          else if (res.data.updateServiceSchedules.errorCode === 'E-SS1-U2/3')
            this.$mcToast.error(this.$t('maintenance.alert.editUnabled'))
          else if (res.data.updateServiceSchedules.errorCode === 'E-SS1-U2/4')
            this.$mcToast.error(this.$t('maintenance.alert.failedFinishMO'))
          else if (res.data.updateServiceSchedules.errorCode === 'E-SS1-U2/5')
            this.$mcToast.error(this.$t('maintenance.alert.failedInProgress'))
          else this.$mcToast.error(res.data.updateServiceSchedules.message)
        })

      this.$bvModal.hide('modal-shortcut-change-status')
      this.$emit('refreshPage')
    },

    handleCreateMO() {
      this.$bvModal.hide('modal-shortcut-change-status')
      this.$bvModal.show('modal-shortcut-create-mo')
    },
  },
}
</script>
